import { render, staticRenderFns } from "./AccountNav.vue?vue&type=template&id=abced126&scoped=true&"
import script from "./AccountNav.vue?vue&type=script&lang=js&"
export * from "./AccountNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abced126",
  null
  
)

export default component.exports